import { render, staticRenderFns } from "./page_404.vue?vue&type=template&id=b14756e6&scoped=true&"
import script from "./page_404.vue?vue&type=script&lang=js&"
export * from "./page_404.vue?vue&type=script&lang=js&"
import style0 from "./page_404.vue?vue&type=style&index=0&id=b14756e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14756e6",
  null
  
)

export default component.exports